import React, { FunctionComponent } from 'react'
import { useRouteMatch } from 'react-router-dom'

import TableContext, {
  createTableContext,
} from '../../../../contexts/TableContext'
import Table from './Table'

export type DetailsSorts =
  | 'adjustments'
  | 'advertiserName'
  | 'commission'
  | 'issuerName'
  | 'processDate'
  | 'productName'
  | 'total'
  | string // NOTE: This is specifically for fixing the table sort type

export interface DetailsFilters {}

export const DetailsTableContext = createTableContext<
  DetailsFilters,
  DetailsSorts
>()

interface DetailsContainerMatchParams {
  paymentId: string
}

const DetailsContainer: FunctionComponent = () => {
  const { params } = useRouteMatch<DetailsContainerMatchParams>()

  return (
    <TableContext<DetailsFilters, DetailsSorts>
      Context={DetailsTableContext}
      defaultSort={{
        by: 'processDate',
        dir: 'desc',
      }}
      defaultPagination={{
        page: 1,
        size: 10,
      }}
    >
      <Table paymentId={params.paymentId} />
    </TableContext>
  )
}

export default DetailsContainer
